"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makePriceData = exports.getPriceDataToUse = void 0;
var makePriceData = exports.makePriceData = function makePriceData(_ref) {
  var hasPreviousPrices = _ref.hasPreviousPrices,
    was = _ref.was,
    then = _ref.then,
    current = _ref.current;
  return {
    hasPreviousPrices: hasPreviousPrices,
    was: was || null,
    then1: then && then[0] ? then[0] : null,
    then2: then && then[1] ? then[1] : null,
    now: current
  };
};
var getPriceDataToUse = exports.getPriceDataToUse = function getPriceDataToUse(_ref2) {
  var _product$variantGroup;
  var product = _ref2.product,
    shouldSelectSize = _ref2.shouldSelectSize,
    selectedColour = _ref2.selectedColour,
    selectedSize = _ref2.selectedSize,
    selectedSku = _ref2.selectedSku;
  var priceData = shouldSelectSize ? makePriceData(product.prices) : makePriceData(selectedSku.localisedPrices);
  var colourPriceData = ((_product$variantGroup = product.variantGroupPrices) === null || _product$variantGroup === void 0 ? void 0 : _product$variantGroup.differentiator) === 'colour' ? product.variantGroupPrices.pricesByDifferentiator && product.variantGroupPrices.pricesByDifferentiator.map(function (el) {
    return {
      colour: el.colour,
      prices: el.prices ? makePriceData(el.prices) : {}
    };
  }) : null;
  if (selectedColour && !selectedSize) {
    var matchedColour = colourPriceData && colourPriceData.find(function (el) {
      return el.colour === selectedColour;
    });
    return matchedColour ? matchedColour.prices : priceData;
  }
  return priceData;
};